import { useAuth } from '../../contexts/AuthContext';
import { canAccessRoute } from '../../lib/routeAccess';
export default function RoleRoute({ path, children }) {
  const { user } = useAuth();
  if (!canAccessRoute(user, path)) return <div role="alert" className="p-6">You do not have access to this page. <a href="/dashboard">Return to dashboard</a></div>;
  return children;
}
